import $ from 'jquery';

$(document).ready(function() {
    $(window).on('scroll', function() {
    	if ($(window).scrollTop()  > $(window).height() / 2) {        
	        $('.js-up').show();
	    } else {
	    	$('.js-up').hide();
	    }
    });
    $(document).on('click', '.js-up', function() {
        $('html, body').animate({
	        scrollTop: 0
	    }, 500);
    });
});


// WEBPACK FOOTER //
// ./src/js/general/up.js